<div id="color-scheme-container" data-cy="color-scheme-container">
  <mat-progress-spinner *ngIf="!colorSchemeList" style="margin-left: auto; margin-right: auto; position: relative; top: 50%; transform: translateY(-50%)" diameter="100" mode="indeterminate" data-cy="color-scheme-loading-spinner"></mat-progress-spinner>
  <mat-grid-list *ngIf="colorSchemeList" cols="6" rowHeight="100%" style="height:100%;" data-cy="color-scheme-grid">
    <mat-grid-tile colspan="2" data-cy="color-scheme-list-tile">
      <mat-card appearance="outlined" style="width:100%; height:100%;" data-cy="color-scheme-list-card">
        <span class="configuration-section-title" data-cy="color-scheme-list-title">Color Schemes</span>
        <div style="height: calc(100% - 100px)" data-cy="color-scheme-table-container">
          <tdo-table #schemeTable [dataSource]="colorSchemeList" (rowSelected)="onSchemeChange($event)" data-cy="color-scheme-table">
            <tdo-table-column [rowTemplate]="name" displayName="Scheme Name" propertyName="ColorSchemeName" data-cy="color-scheme-name-column">
              <ng-template #name let-row><span data-cy="color-scheme-name-value">{{row.ColorSchemeName}}</span></ng-template>
            </tdo-table-column>
            <tdo-table-column [rowTemplate]="del" displayName="" propertyName="xauditDeleted" data-cy="color-scheme-delete-column">
              <ng-template #del let-row><div style="width: 30px; cursor: pointer; color: var(--tdo-secondary); margin-left: auto; margin-right: 0;" (click)="deleteScheme(row.model)" data-cy="color-scheme-delete-btn"><mat-icon>delete</mat-icon></div></ng-template>
            </tdo-table-column>
          </tdo-table>
        </div>
      </mat-card>
    </mat-grid-tile>
    <mat-grid-tile colspan="4" data-cy="color-scheme-details-tile">
      <mat-card appearance="outlined" style="width:100%;height:100%" data-cy="color-scheme-details-card">
        <div style="max-width: 700px;" data-cy="color-scheme-details-container">
          <span class="configuration-section-title" data-cy="color-scheme-details-title">Color Scheme Settings</span>
          <app-tdo-configuration-action-bar [saveDisabled]="selectedColorScheme === null" (newClick)="onNew($event)" (saveClick)="onSave($event)" data-cy="color-scheme-action-bar"></app-tdo-configuration-action-bar>
          <div *ngIf="selectedColorScheme" data-cy="color-scheme-form">
            <mat-form-field style="width:100%" data-cy="color-scheme-name-field">
              <mat-label data-cy="color-scheme-name-label">Name:</mat-label>
              <input matInput placeholder="Name" [formControl]="schemeNameFormControl" data-cy="color-scheme-name-input"/>
            </mat-form-field>
            <br />
            <div style="display: flex;" data-cy="color-scheme-color-pickers">
              <app-tdo-color-picker label="Background Color" style="flex: 1; margin-right: 10px;" placeholder="Background color" [color]="backgroundColor" (colorChange)="onBackgroundColorChange($event)" data-cy="color-scheme-background-picker"></app-tdo-color-picker>
              <app-tdo-color-picker label="Foreground Color" style="flex: 1; margin-left: 10px;" placeholder="Foreground color" [color]="foregroundColor" (colorChange)="onForegroundColorChange($event)" data-cy="color-scheme-foreground-picker"></app-tdo-color-picker>
            </div>
            <br />
            <div data-cy="color-scheme-preview">
              <dx-box direction="row"
                      width="100%"
                      [height]="65"
                      data-cy="color-scheme-preview-box">
                <dxi-item class="rect demo-dark" [style.background-color]="selectedColorScheme.BackColor"
                          [ratio]="1"
                          data-cy="color-scheme-preview-item">
                  <p [style.color]="selectedColorScheme.ForeColor" data-cy="color-scheme-preview-text">Example Text</p>
                </dxi-item>
              </dx-box>
            </div>
          </div>
          <div *ngIf="!selectedColorScheme" (click)="onNew($event)" style="position: relative; top: 200px; width: 100%; text-align: center; cursor: pointer;" data-cy="color-scheme-empty-state">
            Click here, or new to create first item
          </div>
          <br />
          <div class="alert alert-danger" *ngIf="this.errorMessage.length > 0" data-cy="color-scheme-error-message">
            {{errorMessage}}
          </div>
        </div>
      </mat-card>
    </mat-grid-tile>
  </mat-grid-list>
</div>
